import axiosPrivate from "../api/axiosPrivate";

export const bankTransfer = (request) => {
  try {
    const response = axiosPrivate.post(
      "customers/wallet-to-bank-transaction/process",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const liquidationRequest = (request) => {
  try {
    const response = axiosPrivate.post(
      "request-mgt/liquidation-requests/wallet/submit",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const walletTransfer = (request) => {
  try {
    const response = axiosPrivate.post(
      "customers/wallet-to-wallet-transaction/process",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const buyAirtime = (request) => {
  try {
    const response = axiosPrivate.post(
      "transactions/buy-airtime",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const verifyMeter = (request) => {
  try {
    const response = axiosPrivate.post(
      "transactions/verify-meter-number",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const verifySmartCard = (request) => {
  try {
    const response = axiosPrivate.post(
      "transactions/verify-smart-card",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const subscribeCableTV = (request) => {
  try {
    const response = axiosPrivate.post(
      "transactions/subscribe-cable-tv",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const purchaseElectricity = (request) => {
  try {
    const response = axiosPrivate.post(
      "transactions/buy-electricity",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};


export const purchaseDataBundle = (request) => {
  try {
    const response = axiosPrivate.post(
      "transactions/buy-data-bundle",
      request
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getMeterServices = () => {
  try {
    const response = axiosPrivate.get(
      "transactions/get-meter-services"
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getDataBundles = (network_provider) => {
  try {
    const response = axiosPrivate.get(
      `transactions/get-data-bundles/${network_provider}`
    );
    return response;
  } catch (error) {
    return error;
  }
};


export const getCableSubscriptions = (cable_tv_type) => {
  try {
    const response = axiosPrivate.get(
      `transactions/get-subscriptions?cableTvType=${cable_tv_type}`
    );
    return response;
  } catch (error) {
    return error;
  }
};
